module.exports = __webpack_public_path__ + "static/a-xx-157-art-44335bfbd6676f4859c51d7638c3ade1.jpg";